/* Public */
const encrypt = (payload: unknown, encryptMethod: Function = btoa) => encryptMethod(encodeURIComponent(JSON.stringify(payload)));

const decrypt = (encryptedStr: string, decryptMethod: Function = atob) => JSON.parse(decodeURIComponent(decryptMethod(encryptedStr)));

const EncryptService = { encrypt, decrypt };

export default EncryptService;
